import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateOnly: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  TimeOnly: { input: any; output: any; }
};

export type AppMetadata = {
  androidStoreUrl: Scalars['String']['output'];
  iosStoreUrl: Scalars['String']['output'];
  minVersion: Scalars['String']['output'];
};

export type ClientInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nif: Scalars['String']['input'];
  province: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type CreateProfileInput = {
  country: Scalars['String']['input'];
  dateOfBirth: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  identityNumber: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type Mutation = {
  createProfile: Scalars['ID']['output'];
  /** @deprecated not used anymore */
  createSetupSession: Scalars['String']['output'];
  requestCompleteInvoice: TaxInvoice;
  upsertTaxProfile: TaxProfile;
};


export type MutationCreateProfileArgs = {
  input: CreateProfileInput;
};


export type MutationCreateSetupSessionArgs = {
  cancelUrl: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};


export type MutationRequestCompleteInvoiceArgs = {
  input: RequestCompleteInvoiceInput;
};


export type MutationUpsertTaxProfileArgs = {
  input: UpsertTaxProfileInput;
};

export type Query = {
  appMetadata: AppMetadata;
  /** @deprecated Use appMetadata instead */
  getAppMetadata: AppMetadata;
  spotAccessCredential: Scalars['String']['output'];
  taxInvoice: TaxInvoice;
  taxInvoicePdfUrl?: Maybe<Scalars['String']['output']>;
  taxInvoices: TaxInvoiceConnection;
  taxProfile?: Maybe<TaxProfile>;
  visitAccessCredential: Scalars['String']['output'];
};


export type QueryTaxInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxInvoicePdfUrlArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryTaxInvoicesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestCompleteInvoiceInput = {
  client: ClientInput;
  taxInvoiceId: Scalars['ID']['input'];
};

export type TaxInvoice = {
  baseAmount: Scalars['Int']['output'];
  /**
   * TEMPORARY OVERRIDE — not the row's creation timestamp.
   *
   * Released clients render this as the invoice's date, which showed the payment
   * date and led members to read it as the start of the period they had paid
   * for. Until those clients migrate it serves the service period start, falling
   * back to the issue date for invoices with no service period, so every
   * deployed client shows the expected date without a new release.
   *
   * New clients must read servicePeriodStart and transactedAt instead. The
   * override is removed once the force-update floor excludes every build that
   * still reads this field.
   * @deprecated Serves servicePeriodStart during the client migration. Read servicePeriodStart / transactedAt instead.
   */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceType: Scalars['String']['output'];
  number: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  /** Last day of the service period covered, inclusive. Null for one-off charges with no period. */
  servicePeriodEnd?: Maybe<Scalars['DateOnly']['output']>;
  /** First day of the service period covered. Null for one-off charges with no period. */
  servicePeriodStart?: Maybe<Scalars['DateOnly']['output']>;
  taxAmount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  /** Fecha de operación — when the operation took place. Stripe paid_at for originals; inherited from the parent on F3 substitutions and R-series corrections. */
  transactedAt: Scalars['DateTime']['output'];
};

export type TaxInvoiceConnection = {
  endCursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<TaxInvoice>;
};

export type TaxProfile = {
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nif: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  province: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type UpsertTaxProfileInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nif: Scalars['String']['input'];
  province: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type TaxInvoicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type TaxInvoicesQuery = { taxInvoices: { hasMore: boolean, endCursor?: string | undefined, items: Array<{ id: string, number: string, invoiceType: string, baseAmount: number, taxAmount: number, total: number, createdAt: any }> } };

export type TaxInvoicePdfUrlQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type TaxInvoicePdfUrlQuery = { taxInvoicePdfUrl?: string | undefined };

export type RequestCompleteInvoiceMutationVariables = Exact<{
  input: RequestCompleteInvoiceInput;
}>;


export type RequestCompleteInvoiceMutation = { requestCompleteInvoice: { id: string, number: string, invoiceType: string, baseAmount: number, taxAmount: number, total: number, createdAt: any } };

export type TaxProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type TaxProfileQuery = { taxProfile?: { id: string, profileId: string, nif: string, name: string, address: string, city: string, zipCode: string, province: string, country: string } | undefined };

export type UpsertTaxProfileMutationVariables = Exact<{
  input: UpsertTaxProfileInput;
}>;


export type UpsertTaxProfileMutation = { upsertTaxProfile: { id: string, profileId: string, nif: string, name: string, address: string, city: string, zipCode: string, province: string, country: string } };

export type CreateProfileMutationVariables = Exact<{
  input: CreateProfileInput;
}>;


export type CreateProfileMutation = { profileId: string };


export const TaxInvoicesDocument = gql`
    query TaxInvoices($limit: Int, $cursor: String) {
  taxInvoices(limit: $limit, cursor: $cursor) {
    items {
      id
      number
      invoiceType
      baseAmount
      taxAmount
      total
      createdAt
    }
    hasMore
    endCursor
  }
}
    `;

/**
 * __useTaxInvoicesQuery__
 *
 * To run a query within a React component, call `useTaxInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxInvoicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useTaxInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<TaxInvoicesQuery, TaxInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxInvoicesQuery, TaxInvoicesQueryVariables>(TaxInvoicesDocument, options);
      }
export function useTaxInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxInvoicesQuery, TaxInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxInvoicesQuery, TaxInvoicesQueryVariables>(TaxInvoicesDocument, options);
        }
export function useTaxInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxInvoicesQuery, TaxInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxInvoicesQuery, TaxInvoicesQueryVariables>(TaxInvoicesDocument, options);
        }
export type TaxInvoicesQueryHookResult = ReturnType<typeof useTaxInvoicesQuery>;
export type TaxInvoicesLazyQueryHookResult = ReturnType<typeof useTaxInvoicesLazyQuery>;
export type TaxInvoicesSuspenseQueryHookResult = ReturnType<typeof useTaxInvoicesSuspenseQuery>;
export type TaxInvoicesQueryResult = Apollo.QueryResult<TaxInvoicesQuery, TaxInvoicesQueryVariables>;
export const TaxInvoicePdfUrlDocument = gql`
    query TaxInvoicePdfUrl($invoiceId: ID!) {
  taxInvoicePdfUrl(invoiceId: $invoiceId)
}
    `;

/**
 * __useTaxInvoicePdfUrlQuery__
 *
 * To run a query within a React component, call `useTaxInvoicePdfUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxInvoicePdfUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxInvoicePdfUrlQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useTaxInvoicePdfUrlQuery(baseOptions: Apollo.QueryHookOptions<TaxInvoicePdfUrlQuery, TaxInvoicePdfUrlQueryVariables> & ({ variables: TaxInvoicePdfUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxInvoicePdfUrlQuery, TaxInvoicePdfUrlQueryVariables>(TaxInvoicePdfUrlDocument, options);
      }
export function useTaxInvoicePdfUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxInvoicePdfUrlQuery, TaxInvoicePdfUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxInvoicePdfUrlQuery, TaxInvoicePdfUrlQueryVariables>(TaxInvoicePdfUrlDocument, options);
        }
export function useTaxInvoicePdfUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxInvoicePdfUrlQuery, TaxInvoicePdfUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxInvoicePdfUrlQuery, TaxInvoicePdfUrlQueryVariables>(TaxInvoicePdfUrlDocument, options);
        }
export type TaxInvoicePdfUrlQueryHookResult = ReturnType<typeof useTaxInvoicePdfUrlQuery>;
export type TaxInvoicePdfUrlLazyQueryHookResult = ReturnType<typeof useTaxInvoicePdfUrlLazyQuery>;
export type TaxInvoicePdfUrlSuspenseQueryHookResult = ReturnType<typeof useTaxInvoicePdfUrlSuspenseQuery>;
export type TaxInvoicePdfUrlQueryResult = Apollo.QueryResult<TaxInvoicePdfUrlQuery, TaxInvoicePdfUrlQueryVariables>;
export const RequestCompleteInvoiceDocument = gql`
    mutation RequestCompleteInvoice($input: RequestCompleteInvoiceInput!) {
  requestCompleteInvoice(input: $input) {
    id
    number
    invoiceType
    baseAmount
    taxAmount
    total
    createdAt
  }
}
    `;
export type RequestCompleteInvoiceMutationFn = Apollo.MutationFunction<RequestCompleteInvoiceMutation, RequestCompleteInvoiceMutationVariables>;

/**
 * __useRequestCompleteInvoiceMutation__
 *
 * To run a mutation, you first call `useRequestCompleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCompleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCompleteInvoiceMutation, { data, loading, error }] = useRequestCompleteInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCompleteInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<RequestCompleteInvoiceMutation, RequestCompleteInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCompleteInvoiceMutation, RequestCompleteInvoiceMutationVariables>(RequestCompleteInvoiceDocument, options);
      }
export type RequestCompleteInvoiceMutationHookResult = ReturnType<typeof useRequestCompleteInvoiceMutation>;
export type RequestCompleteInvoiceMutationResult = Apollo.MutationResult<RequestCompleteInvoiceMutation>;
export type RequestCompleteInvoiceMutationOptions = Apollo.BaseMutationOptions<RequestCompleteInvoiceMutation, RequestCompleteInvoiceMutationVariables>;
export const TaxProfileDocument = gql`
    query TaxProfile {
  taxProfile {
    id
    profileId
    nif
    name
    address
    city
    zipCode
    province
    country
  }
}
    `;

/**
 * __useTaxProfileQuery__
 *
 * To run a query within a React component, call `useTaxProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaxProfileQuery(baseOptions?: Apollo.QueryHookOptions<TaxProfileQuery, TaxProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxProfileQuery, TaxProfileQueryVariables>(TaxProfileDocument, options);
      }
export function useTaxProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxProfileQuery, TaxProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxProfileQuery, TaxProfileQueryVariables>(TaxProfileDocument, options);
        }
export function useTaxProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxProfileQuery, TaxProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxProfileQuery, TaxProfileQueryVariables>(TaxProfileDocument, options);
        }
export type TaxProfileQueryHookResult = ReturnType<typeof useTaxProfileQuery>;
export type TaxProfileLazyQueryHookResult = ReturnType<typeof useTaxProfileLazyQuery>;
export type TaxProfileSuspenseQueryHookResult = ReturnType<typeof useTaxProfileSuspenseQuery>;
export type TaxProfileQueryResult = Apollo.QueryResult<TaxProfileQuery, TaxProfileQueryVariables>;
export const UpsertTaxProfileDocument = gql`
    mutation UpsertTaxProfile($input: UpsertTaxProfileInput!) {
  upsertTaxProfile(input: $input) {
    id
    profileId
    nif
    name
    address
    city
    zipCode
    province
    country
  }
}
    `;
export type UpsertTaxProfileMutationFn = Apollo.MutationFunction<UpsertTaxProfileMutation, UpsertTaxProfileMutationVariables>;

/**
 * __useUpsertTaxProfileMutation__
 *
 * To run a mutation, you first call `useUpsertTaxProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTaxProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTaxProfileMutation, { data, loading, error }] = useUpsertTaxProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTaxProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTaxProfileMutation, UpsertTaxProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTaxProfileMutation, UpsertTaxProfileMutationVariables>(UpsertTaxProfileDocument, options);
      }
export type UpsertTaxProfileMutationHookResult = ReturnType<typeof useUpsertTaxProfileMutation>;
export type UpsertTaxProfileMutationResult = Apollo.MutationResult<UpsertTaxProfileMutation>;
export type UpsertTaxProfileMutationOptions = Apollo.BaseMutationOptions<UpsertTaxProfileMutation, UpsertTaxProfileMutationVariables>;
export const CreateProfileDocument = gql`
    mutation CreateProfile($input: CreateProfileInput!) {
  profileId: createProfile(input: $input)
}
    `;
export type CreateProfileMutationFn = Apollo.MutationFunction<CreateProfileMutation, CreateProfileMutationVariables>;

/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutation, { data, loading, error }] = useCreateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateProfileMutation, CreateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProfileMutation, CreateProfileMutationVariables>(CreateProfileDocument, options);
      }
export type CreateProfileMutationHookResult = ReturnType<typeof useCreateProfileMutation>;
export type CreateProfileMutationResult = Apollo.MutationResult<CreateProfileMutation>;
export type CreateProfileMutationOptions = Apollo.BaseMutationOptions<CreateProfileMutation, CreateProfileMutationVariables>;